module.exports = __webpack_public_path__ + "static/media/float.f851e00d.png";